/* eslint-disable camelcase */

import { capitalize } from 'lodash';
import React from 'react';
import type { User } from 'types';
import { userRolesToTypes } from 'utils/userRoles';

type ComponentProps = {
  user: User;
  selectedUsers: User[];
  handleSelectUser: (event: React.ChangeEvent<HTMLInputElement>, user: User) => void;
};

const LLUserTableRow: React.FC<ComponentProps> = ({ user, selectedUsers, handleSelectUser }) => {
  const renderTeamNames = (): string => {
    if (user.teams && user.teams.length > 0) {
      return (
        user.teams
          // @ts-ignore
          .filter((t) => t.kind === 'division')
          .reduce(
            (acc, t, index, arr) => `${acc}${t.name}${index !== arr.length - 1 ? ', ' : ''}`,
            ''
          )
      );
    }
    return '–';
  };

  const renderRegionNames = (): string => {
    if (user.teams && user.teams.length > 0) {
      return (
        user.teams
          // @ts-ignore
          .filter((t) => t.kind === 'region')
          .reduce(
            (acc, t, index, arr) => `${acc}${t.name}${index !== arr.length - 1 ? ', ' : ''}`,
            ''
          )
      );
    }
    return '–';
  };

  const renderManagementLevelNames = (): string => {
    if (!user.teams?.length) return '';

    const levels = user.teams
      // @ts-ignore
      .filter((t) => t.kind === 'management-level')
      .map((t) => t.name);

    if (!levels.length) return '';

    return `(${levels.join(', ')})`;
  };

  const selected = !!selectedUsers.find((u) => u.uuid === user.uuid);

  return (
    <tr key={user.uuid} className="table-wrapper__new-tr table-row align-top">
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content min-h-5 h-auto flex">
          <input
            id={`checkbox-user-${user.uuid}`}
            data-testid="select-button"
            type="checkbox"
            className="cursor-pointer form-checkbox litlingo-checkbox w-5 h-5"
            onClick={(e): void => e.stopPropagation()}
            onChange={(e): void => {
              handleSelectUser(e, user);
            }}
            checked={selected}
          />
        </div>
      </td>

      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content min-h-5 h-auto pr-4 flex flex-col text-body">
          <div className="w-full flex flex-row justify-between">
            <span className="truncate">
              {user.name} {renderManagementLevelNames()}
            </span>
          </div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content min-h-5 h-auto pr-4 flex flex-col text-body">
          <div className="w-full truncate">{user.email}</div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content min-h-5 h-auto pr-4 flex items-center">
          <div className="text-body clamped-text-2 overflow-hidden">
            {userRolesToTypes(user.roles) !== null && userRolesToTypes(user.roles).length > 0
              ? userRolesToTypes(user.roles).map((item, index) => {
                  if (index === 0) {
                    return capitalize(item.label);
                  }
                  return `, ${capitalize(item.label)}`;
                })
              : '–'}
          </div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content min-h-5 h-auto pr-4 flex items-center">
          <div className="text-left text-body clamped-text-2 overflow-hidden">
            {renderTeamNames()}
          </div>
        </div>
      </td>
      <td className="table-wrapper__new-td">
        <div className="table-wrapper__new-cell-content min-h-5 h-auto pr-4 flex items-center">
          <div className="text-left text-body clamped-text-2 overflow-hidden">
            {renderRegionNames()}
          </div>
        </div>
      </td>
    </tr>
  );
};

export default LLUserTableRow;
